export const lensAddresses = {
  accountLens: "0x9578D17d2e1AA70EA6f9eC8A39967bfD1c6F6217",
  eulerEarnVaultLens: "0xb8092E858547a8314A6501E18FA2BFC9AB2Eb578",
  irmLens: "0x56Fb9F68354aF7DAE4E3b2067B53C498ECD053C6",
  oracleLens: "0x301a83Cf9ffbDe64DbBD7F7988e900704cbCa2cb",
  utilsLens: "0x30be272d1441E9935BCBeA2Cd924cD5e568A052e",
  vaultLens: "0x84641751808f85F54344369036594E1a7301a414",
} as const
